import {createClient} from '@supabase/supabase-js';

// Browser-safe AAF Apps environment variables. Fail closed if deployment
// configuration is missing; never silently route accounts to Website Tools.
const SUPABASE_URL=import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY=import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
if(!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY)throw new Error('CutScript Supabase is not configured.');
const supabase=createClient(SUPABASE_URL,SUPABASE_PUBLISHABLE_KEY,{
  auth:{persistSession:true,autoRefreshToken:true}
});
export default supabase;
